const TextSwatch = ({ text }) => (
  <div className="velorbis-customizer-text-swatch">{text}</div>
)
export default TextSwatch
